<!-- eslint-disable no-console -->
<script setup lang="ts">
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | Dluhopisomat` : 'Dluhopisomat'
  },
  link: [
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico?v1.0.1' },
    { rel: 'preload', type: 'image/svg+xml', href: '/public/sprite.svg' },
    // preconnect and dns-prefetch for external domains
    { rel: 'preconnect', href: 'https://cdn-widget.callpage.io', crossorigin: 'anonymous' },
    { rel: 'preconnect', href: 'https://cdnjs.cloudflare.com', crossorigin: 'anonymous' },
    { rel: 'preconnect', href: 'https://www.googletagmanager.com', crossorigin: 'anonymous' },
    { rel: 'preconnect', href: 'https://api.storyblok.com', crossorigin: 'anonymous' },
    { rel: 'dns-prefetch', href: 'https://cdn-widget.callpage.io' },
    { rel: 'dns-prefetch', href: 'https://cdnjs.cloudflare.com' },
  ],
})

useCallpageTracking()
</script>

<template>
  <div class="flex flex-1 flex-col bg-[#fdfdff]">
    <NuxtLayout>
      <NuxtPage :style="{ flexGrow: 1 }" />
    </NuxtLayout>
  </div>
</template>

<style>
#__nuxt {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.sprite-container {
  display: none !important;
}

#sentry-feedback {
  width: initial !important;
}
</style>
